import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { Box, Flex } from "theme-ui"
import moment from "moment"

const query = graphql`
    {
        testimonials: allStrapiTestimonial(
            filter: {
                company: { shortname: { eq: "EDN" } }
                type: { eq: "client" }
            }
        ) {
            edges {
                node {
                    author
                    quote
                    createdAt
                }
            }
        }
    }
`

// markup
const IndexPage = () => {
    const data = useStaticQuery(query)
    return data.testimonials.edges.map((testi, idx) => (
        <Flex
            sx={{
                borderBottom: "2px solid",
                borderColor: "primary",
                flexDirection: "column",
                marginBottom: "1.5rem",
            }}
            key={idx}
        >
            <Flex sx={{ justifyContent: "space-between" }}>
                <h3>
                    <p>{testi.node.author}</p>
                </h3>
                <p>{moment(testi.createdAt).format("MM-DD-YYYY")}</p>
            </Flex>
            <Box>
                <p>
                    <div
                        dangerouslySetInnerHTML={{ __html: testi.node.quote }}
                    ></div>
                </p>
            </Box>
        </Flex>
    ))
}

export default IndexPage
